import { CheckCircle2, AlertTriangle } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { formatEUR } from "@/lib/i18n";

export default function QuadraturaBadge({ quadratura }) {
  const { t, lang } = useLang();
  if (!quadratura) return null;
  const { ok, ok_attivo_passivo, ok_utile, diff_attivo_passivo, diff_utile } = quadratura;

  if (ok) {
    return (
      <div
        data-testid="quadratura-badge"
        className="flex items-center gap-2 rounded-full border border-green-200 bg-green-50 px-3 py-1.5 text-xs font-medium text-green-700"
      >
        <CheckCircle2 className="h-3.5 w-3.5" strokeWidth={2} />
        {t("quadr_ok")}
      </div>
    );
  }

  return (
    <div
      data-testid="quadratura-badge"
      className="flex flex-wrap items-center gap-x-3 gap-y-1 rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-xs text-amber-900"
    >
      <div className="flex items-center gap-1.5 font-medium">
        <AlertTriangle className="h-3.5 w-3.5" strokeWidth={2} />
        {t("quadr_ko")}
      </div>
      {!ok_attivo_passivo && (
        <span className="font-mono">
          {t("quadr_ap")}: <b>{formatEUR(diff_attivo_passivo, lang)}</b>
        </span>
      )}
      {!ok_utile && (
        <span className="font-mono">
          {t("quadr_utile")}: <b>{formatEUR(diff_utile, lang)}</b>
        </span>
      )}
    </div>
  );
}
